import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import "./View.css";
import jobImageOne from "../../../../Images/job-1.png";
import jobImageTwo from "../../../../Images/job-2.png";
import tempOne from "../../../../Images/t1.jpg";
import Breadcrumb from "../../../Layout/Breadcrumb/Breadcrumb";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import Nav from "../../../Layout/Nav/Nav";
// import { useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import ButtonCall from "../../UiSpecification/Button/Button";
import UnLinkButton from "../../UiSpecification/UnLinkButton/UnLinkButton";
import ActionButtonCall from "../../UiSpecification/ActionButton/ActionButton";

import { MasterData } from "../../../Helpers/Data/MasterData/MasterData";
import { CatMasterData } from "../../../Helpers/Data/CatMasterData/CatMasterData";
import { Company } from "../../../Helpers/Data/Company/Company";
import { Contact } from "../../../Helpers/Data/Contact/Contact";
import { Unit } from "../../../Helpers/Data/Unit/Unit";

import DataTable, { createTheme } from "react-data-table-component";

// function ActionButtonCall(props) {

//   return (
//     iconButtons
//     .filter((ibtn) => ibtn.name == props.btnname)
//     .map((filteredIbtn) => <li key={filteredIbtn.id}>{filteredIbtn.button}</li>)
//   );
// }

function AddJob() {
  const [MasterDataStore, setMasterDataStore] = useState(MasterData);
  // console.log({ MasterDataStore });

  const [CatMasterDataStore, setCatMasterDataStore] = useState(CatMasterData);
  // console.log({ CatMasterDataStore });

  const [SelectedMasterDataStore, setSelectedMasterDataStore] = useState({
    MasterDataCategory: "",
  });
  const handleMasterDataInput = (e) => {
    setSelectedMasterDataStore({
      ...SelectedMasterDataStore,
      [e.target.name]: e.target.value,
    });
  };

  const [CompanyStore, setCompanyStore] = useState(Company);
  // console.log({ CompanyStore });

  const [ContactStore, setContactStore] = useState(Contact);
  // console.log({ ContactStore });

  const [SelectedCompanyStore, setSelectedCompanyStore] = useState({
    company: "",
  });
  const handleCpmpanyInput = (e) => {
    setSelectedCompanyStore({
      ...SelectedCompanyStore,
      [e.target.name]: e.target.value,
    });
  };
  // console.log({SelectedCompanyStore});

  // List Table
  const columns = [
    {
      name: "Ref No",
      selector: (row) => row.code,
      sortable: true,
    },
    // {
    //   name: "Image",
    //   selector: (row) => row.image,
    //   sortable: false,
    // },
    {
      name: "Title",
      selector: (row) => row.name,
      sortable: true,
    },
 
    {
      name: "NOS",
      selector: (row) => row.nos,
      sortable: true,
    },
    {
      name: "Unit",
      selector: (row) => row.unit,
      // width: "720px",
      sortable: true,
    },
    // {
    //   name: "Action",
    //   selector: (row) => row.action,
    //   sortable: true,
    // },
  ];

  const data = [
    {
      id: 1,
      code: "I001",
      name: "Checked central air conditioning unit",
      image:<img className="tbl-i-e" src={tempOne} alt="" />,
      nos: 1,
      unit: "NOS",
      // action: (
      //   <div className="icon-button-parent">
      //     {<ActionButtonCall btnname="close" />}
      //   </div>
      // ),
    },
    {
      id: 2,
      code: "I002",
      name: "Installed thermostat wall plate",
      image:<img className="tbl-i-e" src={tempOne} alt="" />,
      nos: 1,
      unit: "NOS",
      // action: (
      //   <div className="icon-button-parent">
      //     {<ActionButtonCall btnname="close" />}
      //   </div>
      // ),
    },
    {
      id: 3,
      code: "I003",
      name: "Re-wired low volt in to new one",
      image:<img className="tbl-i-e" src={tempOne} alt="" />,
      nos: 5,
      unit: "NOS",
      // action: (
      //   <div className="icon-button-parent">
      //     {<ActionButtonCall btnname="close" />}
      //   </div>
      // ),
    },
    {
      id: 4,
      code: "I004",
      name: "Replaced new digital thermostat",
      image:<img className="tbl-i-e" src={tempOne} alt="" />,
      nos: 1,
      unit: "NOS",
      // action: (
      //   <div className="icon-button-parent">
      //     {<ActionButtonCall btnname="close" />}
      //   </div>
      // ),
    },

    {
      id: 5,
      code: "I005",
      name: "Programed thermostat in to heat pump mode",
      image:<img className="tbl-i-e" src={tempOne} alt="" />,
      nos: 3,
      unit: "NOS",
      // action: (
      //   <div className="icon-button-parent">
      //     {<ActionButtonCall btnname="close" />}
      //   </div>
      // ),
    },
  ];

  const [records, setRecords] = useState(data);

  // function handleFilter(event) {
  //   const newData = data.filter((row) => {
  //     return row.title.toLowerCase().includes(event.target.value.toLowerCase());
  //   });
  //   setRecords(newData);
  // }
  // End List Table

  // Add Item Modal
  const [showAddJob, setShowAddJob] = useState(false);
  const handleClose = () => setShowAddJob(false);
  const handleShow = () => setShowAddJob(true);

  // Add Item Inventory
  const [addJobInventoryType, SetaddJobInventoryType] = useState("master");

  // All Added items
  const [insrtedAllTypeItemStore, setinsrtedAllTypeItemStore] = useState([]);

  // Add Inventory Type Body
  // const [jobInventoryBodyType, SetjobInventoryBodyType] = useState("master");

  // Inventor Item Insert
  //   master
  // ======
  // selectMasterItem
  // MasterItemCount

  // custom
  // =====
  // CustomItemName
  // CustomItemDescription
  // CustomItemCount
  // CustomItemUnit

  //  ============= Master Item add ===========
  const [insertMasterItem, setinsertMasterItem] = useState({
    selectMasterItem: "",
    MasterItemCount: "",
  });
  const insertMasterItemParser = (e) => {
    setinsertMasterItem({
      ...insertMasterItem,
      [e.target.name]: e.target.value,
    });
  };
  const [insertMasterItemStore, setinsertMasterItemStore] = useState([]);

  //  ============ Custom Item Add ===========
  const [insertCustomItem, setinsertCustomItem] = useState({
    CustomItemName: "",
    CustomItemDescription: "",
    CustomItemCount: "",
    CustomItemUnit: "",
    CustomItemPrice: "",
  });
  const insertCustomItemParser = (e) => {
    setinsertCustomItem({
      ...insertCustomItem,
      [e.target.name]: e.target.value,
    });
  };
  const [insertCustomItemStore, setinsertCustomItemStore] = useState([]);

  // ======Submit=====

  // const SubmitinsertAllItemParser = (e) => {
  //   addJobInventoryType == "master"
  //     ?
  //     setinsertMasterItemStore({
  //       selectMasterItem: insertMasterItem.selectMasterItem,
  //       MasterItemCount: insertMasterItem.MasterItemCount,
  //     })  :
  // setinsertCustomItemStore({
  //   CustomItemName :insertCustomItem.CustomItemName,
  //   CustomItemDescription :insertCustomItem.CustomItemDescription,
  //   CustomItemCount :insertCustomItem.CustomItemCount,
  //   CustomItemUnit :insertCustomItem.CustomItemUnit,
  // });

  //   addJobInventoryType == "master"
  //   ? setinsrtedAllTypeItemStore({...insrtedAllTypeItemStore, insertMasterItemStore})
  //   : setinsrtedAllTypeItemStore({...insrtedAllTypeItemStore, insertCustomItemStore});
  // };

  const SubmitinsertAllItemParser = () => {
    if (addJobInventoryType == "master") {
      if (
        insertMasterItem.selectMasterItem != "" &&
        insertMasterItem.MasterItemCount != ""
      ) {
        setinsertMasterItemStore((insertMasterItemStore) => [
          ...insertMasterItemStore,
          insertMasterItem,
        ]);
        setinsrtedAllTypeItemStore((insrtedAllTypeItemStore) => [
          ...insrtedAllTypeItemStore,
          insertMasterItem,
        ]);
        // console.log(nameTwo);
        setinsertMasterItem({
          selectMasterItem: "",
          MasterItemCount: "",
        });
      }

      // setNameThree({
      //   ...nameThree,
      //   nameTwo,
      // });
      // working===setNameThree(prevStateArray => [...prevStateArray, nameTwo]);

      // console.log(nameThree);
    } else {
      if (
        insertCustomItem.CustomItemName != "" &&
        insertCustomItem.CustomItemDescription != "" &&
        insertCustomItem.CustomItemCount != "" &&
        insertCustomItem.CustomItemUnit != ""
      ) {
        setinsertCustomItemStore((insertCustomItemStore) => [
          ...insertCustomItemStore,
          insertCustomItem,
        ]);
        setinsrtedAllTypeItemStore((insrtedAllTypeItemStore) => [
          ...insrtedAllTypeItemStore,
          insertCustomItem,
        ]);
        // console.log(nameTwo);
        setinsertCustomItem({
          CustomItemName: "",
          CustomItemDescription: "",
          CustomItemCount: "",
          CustomItemUnit: "",
          CustomItemPrice: "",
        });
      }
      // setNameThree({
      //   ...nameThree,
      //   nameTwoB,
      // });
      // working====setNameThree(prevStateArray => [...prevStateArray, nameTwoB]);

      // console.log(nameThree);
    }
    // toggler == true ? console.log("True") : console.log("false");
  };

  console.log(insrtedAllTypeItemStore);
  return (
    <div className="page-con">
      <div className="page-nav">
        <Nav />
      </div>

      <div className="page-body">
        <Header />

        <div className="comb-sec breadcrumb-sec">
          <div className="container-fluid px-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb my-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/job">Job List</Link>
                </li>
                <li className="breadcrumb-item">
                  <span>View Job</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="page-content-container">
          {
            // insrtedAllTypeItemStore.map((item) => (
            //                   <p>
            //                     <>
            //                       xx
            //                       {/* {SelectedCompanyStore.company} */}
            //                     </>
            //                   </p>
            //                 ))
          }

          <Container className="cus-con-elmt">
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="page-top-info-style-2">
                  <div className="page-top-info-style-2-inner">
                    <div className="page-top-info-style-2-col page-top-info-style-2-col-3_1">
                      <div className="page-top-info-style-2-col-row-h">
                        Job No
                      </div>
                      <div className="page-top-info-style-2-col-row-c">
                      J001
                      </div>
                    </div>

                    <div className="page-top-info-style-2-col page-top-info-style-2-col-3_1">
                      <div className="page-top-info-style-2-col-row-h">
                        Job Date
                      </div>
                      <div className="page-top-info-style-2-col-row-c">
                      12/22/24
                      </div>
                    </div>

                    <div className="page-top-info-style-2-col page-top-info-style-2-col-3_1">
                      <div className="page-top-info-style-2-col-row-h">
                        Job Status
                      </div>
                      <div className="page-top-info-style-2-col-row-c">
                        Open
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">
                    Customer Details
                  </Form.Label>
                  <div className="records-con-sec">
                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Company
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                          <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>Las Ventanas</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Customer
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>Strathern Park</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Location
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>11111 Strathern Street, Sun Valley.</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Phone
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>234-479-5555</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Email
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>strathern23@gmail.com</span>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">
                    Technician Details
                  </Form.Label>
                  <div className="records-con-sec">
                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Technician
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>Recusandae Itaque</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Code
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                         <span>T024</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Job Type
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>AC Technician, Electrician</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Phone
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>765-479-4444</span>
                        </div>
                      </div>
                    </span>

                    <span className="records-con-elmt">
                      <div className="records-con-elmt-sec">
                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-h">
                          Email
                        </div>

                        <div className="records-con-elmt-sec-col records-con-elmt-sec-col-c">
                        <span className="records-con-elmt-sec-col-seperator">&nbsp;:</span>
                          <span>recusandaeiq@gmail.com</span>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">Job Title</Form.Label>
                  <p>Checked central AC and heating system.</p>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">Job Description</Form.Label>
                  <p>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti atque
                    corrupti quos dolores et quas molestias excepturi sint
                    occaecati cupiditate non provident, similique sunt in culpa
                    qui officia deserunt mollitia animi, id est laborum et
                    dolorum fuga. Et harum quidem rerum facilis est et expedita
                    distinctio.
                  </p>
                </div>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">Category</Form.Label>
                  <p>Air Conditioner</p>
                </div>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">Date Ordered</Form.Label>
                  <p>12/22/24</p>
                </div>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">Date Completed</Form.Label>
                  <p>12/24/24</p>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">Images</Form.Label>
                  <p className="i-list-con">
                    <img className="job-view-i-1" src={jobImageOne} alt="" />
                    <img className="job-view-i-1" src={jobImageTwo} alt="" />
                  </p>
                </div>
              </Col>
            </Row>
            {/* <Row>
              <Col
                md={{ span: 3, offset: 3 }}
              >{`md={{ span: 3, offset: 3 }}`}</Col>
              <Col
                md={{ span: 3, offset: 3 }}
              >{`md={{ span: 3, offset: 3 }}`}</Col>
            </Row>
            <Row>
              <Col
                md={{ span: 6, offset: 3 }}
              >{`md={{ span: 6, offset: 3 }}`}</Col>
            </Row> */}
          </Container>

          <br></br>
          <br></br>

          <div className="dataTable-con">
            <div className="dataTable-serach-con dataTable-serach-con-button">
              <div className="dataTable-serach-con-button-left h-elmt-class">
                Items
              </div>
              {/* 
              <div className="dataTable-serach-con-button-right">
              
              </div> */}
            </div>
            <div className="dataTable-table-con dataTable-table-guest-view-item">
              <DataTable
                columns={columns}
                data={records}
                fixedHeader
                pagination
                // theme="solarized"
              />
            </div>
          </div>

          <Container className="cus-con-elmt">
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobDesc">Note</Form.Label>
                  <p>
                    Checked central AC and heating system. Unit not starting.
                    <br />
                    Opened attic and checked air handler in attic.
                    <br />
                    Found unit low voltage wire was shorted and transformer was
                    burnt out.
                    <br />
                    Replaced transformer and repair low voltage issue.
                    <br />
                    Checked thermostat and existing thermostat was not working.
                    <br />
                    Removed faulty thermostat and replaced new thermostat.
                  </p>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobDesc">Warnings and Suggestions</Form.Label>
                  <p>
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>

          <Container className="cus-con-elmt bottom-btn-set-sec">
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="grid-sec-row">
                  <div className="grid-sec-col grid-sec-col-left-align grid-667max-sec-col-center-align grid-sec-col-2 max-767-hider-elmtXXX">
                    <ButtonCall urlto="/job" btnname="back" title="Back" />
                  </div>

                  <div className="grid-sec-col grid-sec-col-right-align grid-667max-sec-col-center-align grid-sec-col-2 max-767-hider-elmt"></div>
                </div>
              </Col>
            </Row>
          </Container>

          <>
            <Modal
              show={showAddJob}
              onHide={handleClose}
              className="full-modal-con"
            >
              <Modal.Header closeButton>
                <Modal.Title>Add New Items to the Job</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="checker-inline-con">
                    <Form.Check
                      type="radio"
                      id="itemtype-master"
                      label="Master Item"
                      name="itemtype"
                      className="radio-btn-elmt"
                      value="master"
                      onChange={() => {
                        SetaddJobInventoryType("master");
                        setinsertMasterItem({
                          selectMasterItem: "",
                          MasterItemCount: "",
                        });
                        setinsertCustomItem({
                          CustomItemName: "",
                          CustomItemDescription: "",
                          CustomItemCount: "",
                          CustomItemUnit: "",
                          CustomItemPrice: "",
                        });
                        // SetjobInventoryBodyType("master");
                      }}
                      checked={addJobInventoryType == "master"}
                    />

                    <Form.Check
                      type="radio"
                      id="itemtype-cutom"
                      label="Custom Item"
                      name="itemtype"
                      className="radio-btn-elmt"
                      value="custom"
                      onChange={() => {
                        SetaddJobInventoryType("custom");
                        setinsertMasterItem({
                          selectMasterItem: "",
                          MasterItemCount: "",
                        });
                        setinsertCustomItem({
                          CustomItemName: "",
                          CustomItemDescription: "",
                          CustomItemCount: "",
                          CustomItemUnit: "",
                          CustomItemPrice: "",
                        });
                        // SetjobInventoryBodyType("custom");
                      }}
                      checked={addJobInventoryType == "custom"}
                    />
                  </div>

                  {addJobInventoryType == "master" && (
                    <>
                      <Container className="cus-con-elmt">
                        <Row>
                          <Col xs={12} md={6} lg={6}>
                            <div className="form-group-con">
                              <div className="form-group-con-btn">
                                <div className="form-group-con-btn-col-1">
                                  <Form.Label htmlFor="addJobSelectCompany">
                                    Category
                                  </Form.Label>

                                  <Form.Select
                                    value={
                                      SelectedMasterDataStore.MasterDataCategory
                                    }
                                    name="MasterDataCategory"
                                    // value={SelectedCompanyStore.company}
                                    // onChange={handleCpmpanyInput}
                                    onChange={handleMasterDataInput}
                                    id="MasterDataCategory"
                                    aria-label="Default select example"
                                  >
                                    <option>Select Master Item Category</option>
                                    {CatMasterDataStore.map((item) => (
                                      <option
                                        key={item.id}
                                        value={item.code}
                                        name={item.code}
                                      >
                                        {item.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                              </div>
                            </div>
                          </Col>

                          <Col xs={12} md={6} lg={6}>
                            <div className="form-group-con">
                              <div className="form-group-con-btn">
                                <div className="form-group-con-btn-col-1">
                                  <Form.Label htmlFor="addJobSelectCustomer">
                                    Item
                                  </Form.Label>
                                  <Form.Select
                                    value={insertMasterItem.selectMasterItem}
                                    onChange={insertMasterItemParser}
                                    id="selectMasterItem"
                                    name="selectMasterItem"
                                    aria-label="Default select example"
                                  >
                                    <option>Select Master Item</option>
                                    {MasterDataStore.filter(
                                      (masterdata) =>
                                        masterdata.enable == 1 &&
                                        masterdata.category ==
                                          `${SelectedMasterDataStore.MasterDataCategory}`
                                    ).map((item) => (
                                      <option key={item.id} value={item.code}>
                                        {item.code} - {item.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* new 1 + 2 */}
                          <Col xs={12} md={6} lg={6}>
                            <div className="form-group-con">
                              <div className="form-group-con-btn form-group-con-btn-one-h">
                                <div
                                  className="form-group-con-btn-col-1"
                                  style={{ width: "120px" }}
                                >
                                  <Form.Label htmlFor="addJobTitle">
                                    Item Count
                                  </Form.Label>
                                  <Form.Control
                                    value={insertMasterItem.MasterItemCount}
                                    type="number"
                                    id="MasterItemCount"
                                    name="MasterItemCount"
                                    onChange={insertMasterItemParser}
                                    min="1"
                                    // aria-describedby="passwordHelpBlock"
                                  />
                                </div>

                                <div className="form-group-con-btn-col-2">
                                  {/* <div className="form-group-con-btn-col-2-none-h-elmt"> */}

                                  {/* use this */}
                                  {/* {MasterDataStore.filter(
                                      (masterdata) =>
                                        masterdata.enable == 1 &&
                                        masterdata.code ==
                                          `${insertMasterItem.selectMasterItem}`
                                    ).map((item) => (
                                      <span key={item.id}>{item.unit}</span>
                                    ))} */}
                                  <div
                                    className="form-group-con-btn-col-2"
                                    style={{ width: "90px" }}
                                  >
                                    <Form.Label htmlFor="addJobSelectCustomer">
                                      Unit
                                    </Form.Label>
                                    <Form.Select
                                      value={insertCustomItem.CustomItemUnit}
                                      onChange={insertCustomItemParser}
                                      id="CustomItemUnit"
                                      name="CustomItemUnit"
                                      aria-label="Default select example"
                                    >
                                      <option>NOs</option>
                                      {Unit.map((item) => (
                                        <option key={item.id} value={item.code}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                    {/* </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>

                          <Col xs={12} md={4} lg={4}>
                            <div className="form-group-con">
                              <div className="form-group-con-btn">
                                <div className="form-group-con-btn-col-1">
                                  <Form.Label htmlFor="addJobSelectCustomer">
                                    Price
                                  </Form.Label>

                                  {/* <Form.Select
                                    value={insertMasterItem.selectMasterItem}
                                    onChange={insertMasterItemParser}
                                    id="selectMasterItem"
                                    name="selectMasterItem"
                                    aria-label="Default select example"
                                  >
                                    <option>Item Price</option> */}
                                  {MasterDataStore.filter(
                                    (masterdata) =>
                                      masterdata.enable == 1 &&
                                      masterdata.code ==
                                        `${insertMasterItem.selectMasterItem}`
                                  ).map((item) => (
                                    <option key={item.id} value={item.code}>
                                      <>
                                        {item.price &&
                                          item.price.toLocaleString()}
                                      </>
                                    </option>
                                  ))}
                                  {/* </Form.Select> */}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </>
                  )}

                  {addJobInventoryType == "custom" && (
                    <>
                      <Container className="cus-con-elmt">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="form-group-con">
                              <Form.Label htmlFor="addJobTitle">
                                Item Name
                              </Form.Label>
                              <Form.Control
                                value={insertCustomItem.CustomItemName}
                                type="text"
                                id="CustomItemName"
                                name="CustomItemName"
                                onChange={insertCustomItemParser}
                                // aria-describedby="passwordHelpBlock"
                              />
                              {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                            </div>
                          </Col>

                          <Col xs={12} md={12} lg={12}>
                            <div className="form-group-con">
                              <Form.Label htmlFor="addJobDesc">
                                Description
                              </Form.Label>
                              <FloatingLabel label="">
                                <Form.Control
                                  value={insertCustomItem.CustomItemDescription}
                                  as="textarea"
                                  placeholder=""
                                  style={{ height: "100px" }}
                                  id="CustomItemDescription"
                                  name="CustomItemDescription"
                                  onChange={insertCustomItemParser}
                                />
                              </FloatingLabel>
                            </div>
                          </Col>

                          {/* <Col xs={12} md={4} lg={4}>
                            <div className="form-group-con">
                              <Form.Label htmlFor="addJobTitle">
                                Unit
                              </Form.Label>
                              <Form.Control
                                value={insertCustomItem.CustomItemUnit}
                                type="text"
                                id="CustomItemUnit"
                                name="CustomItemUnit"
                                onChange={insertCustomItemParser}
                              />
                             
                            </div>
                          </Col> */}

                          <Col xs={12} md={6} lg={6}>
                            <div className="form-group-con">
                              <div className="form-group-con-btn">
                                <div
                                  className="form-group-con-btn-col-1"
                                  style={{ width: "120px" }}
                                >
                                  <Form.Label htmlFor="addJobTitle">
                                    Item Count
                                  </Form.Label>
                                  <Form.Control
                                    value={insertCustomItem.CustomItemCount}
                                    type="number"
                                    id="CustomItemCount"
                                    name="CustomItemCount"
                                    onChange={insertCustomItemParser}
                                    min="1"
                                    // aria-describedby="passwordHelpBlock"
                                  />
                                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                                </div>

                                <div
                                  className="form-group-con-btn-col-2"
                                  style={{ width: "90px" }}
                                >
                                  <Form.Label htmlFor="addJobSelectCustomer">
                                    Unit
                                  </Form.Label>
                                  <Form.Select
                                    value={insertCustomItem.CustomItemUnit}
                                    onChange={insertCustomItemParser}
                                    id="CustomItemUnit"
                                    name="CustomItemUnit"
                                    aria-label="Default select example"
                                  >
                                    <option>NOs</option>
                                    {Unit.map((item) => (
                                      <option key={item.id} value={item.code}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                              </div>
                            </div>
                          </Col>

                          <Col xs={12} md={6} lg={6}>
                            <div
                              className="form-group-con"
                              style={{ width: "120px" }}
                            >
                              <Form.Label htmlFor="addJobTitle">
                                Price
                              </Form.Label>
                              <Form.Control
                                value={insertCustomItem.CustomItemPrice}
                                type="number"
                                id="CustomItemPrice"
                                name="CustomItemPrice"
                                onChange={insertCustomItemParser}
                                min="1"
                                // aria-describedby="passwordHelpBlock"
                              />
                              {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </>
                  )}
                </Form>
              </Modal.Body>
              <Modal.Footer>
                {
                  <UnLinkButton
                    trigerClick={handleClose}
                    btnname="close"
                    title="Close"
                  />
                }
                {/* SubmitinsertMasterItemParser */}
                {
                  <UnLinkButton
                    trigerClick={SubmitinsertAllItemParser}
                    btnname="add"
                    title="Add Item"
                  />
                }
              </Modal.Footer>
            </Modal>
          </>
        </div>

        <Footer />
      </div>
    </div>
  );
}
export default AddJob;
